import logo from "assets/images/logo.png";
import logo2x from "assets/images/logo@2x.png";
import logo3x from "assets/images/logo@3x.png";
import footerLogo from "assets/images/footer-logo.png";

const images = {
   logo,
   logo2x,
   logo3x,
   footerLogo,
};
export default images;
